import isAHandledError from './isAHandledError';

/**
 * A utility to be used in catch blocks to only rethrow the error if it wasn't
 * one handled by useErrorHandledMutation.
 * @param error The caught error.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const throwOnlyUnhandledErrors = (error: any) => {
  if (!isAHandledError(error)) {
    throw error;
  }
};

export default throwOnlyUnhandledErrors;
